import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TagManagementService } from 'src/app/_services/new-settings/tag-management.service';

@Component({
    selector: 'app-tag-management',
    templateUrl: './tag-management.component.html',
    styleUrls: ['./tag-management.component.scss'],
    standalone: false
})
export class TagManagementComponent implements OnInit {

  allTags: Object[] = [];
  tagInput: UntypedFormControl = new UntypedFormControl(null);
  tagInputError: Boolean = false;
  tagInputSpecialCharError: Boolean = false;
  editTagInput: UntypedFormControl = new UntypedFormControl(null);
  editTagInputError: Boolean = false;
  editInputSpecialCharError: Boolean = false;
  tagLoader: Boolean = false;
  showSpinnerLoader: Boolean = false;
  showActionSpinnerLoader: Boolean = false;
  successMessage: String = '';
  errorMessage: String = '';
  tagDetails: any;
  inputRegex = /^[a-zA-Z0-9\s']+$/;

  @ViewChild('tagEditModel') tagEditModel: TemplateRef<any>;
  @ViewChild('tagDeleteModel') tagDeleteModel: TemplateRef<any>;

  constructor(
    private modalService: NgbModal,
    private tagmanagementservice: TagManagementService
  ) { }

  ngOnInit() {

    this.fetchAllTags();
    this.tagInput.valueChanges.subscribe((value: any) => {
      if (value && value.length > 0 && !this.inputRegex.test(value)) {
        this.tagInputSpecialCharError = true;
      } else {
        this.tagInputSpecialCharError = false;
      }
      this.tagInputError = false;
    });

    this.editTagInput.valueChanges.subscribe((value: any) => {
       if (value && value.length > 0 && !this.inputRegex.test(value)) {
        this.editInputSpecialCharError = true;
      } else {
        this.editInputSpecialCharError = false;
      }
      this.editTagInputError = false;
    });

  };

  /**
   * Fetch User All Tags
   */
  fetchAllTags() {
    this.tagLoader = true;
    const data = { tagtext: '' }
    this.tagmanagementservice.getAllTags(data).subscribe((res: any) => {
      if (res && res.status == 'success') {
        this.allTags = res.message;
      } else {
        this.allTags = [];
      }
      this.tagLoader = false;
    })
  };

  /**
   * Create New Tag
   */
  addTag() {
    if (!this.tagInput.value || this.tagInputSpecialCharError) return;
    this.showSpinnerLoader = true;
    const data = {
      tagtext: this.tagInput.value
    };

    this.tagmanagementservice.createTags(data).subscribe((res: any) => {
      if (res && res.status == 'success') {
        if (res.message == 'Tag is already present') {
          this.tagInputError = true;
        } else {
          this.successMessage = 'Tag Created Successfully!';
          this.fetchAllTags();
          this.tagInput.setValue(null);
          this.tagInputError = false;
          setTimeout(() => this.successMessage = '', 5000);
        }
      } else {
        this.errorMessage = 'Something went wrong';
        setTimeout(() => this.errorMessage = '', 5000);
      }
      this.showSpinnerLoader = false;
      this.dismiss();
    })
  }

  /**
   * Open Action Tag Model
   * @param tag 
   */
  openModel(tag: Object, modelType: String) {
    if(!tag) return;
    this.tagDetails = tag;
    this.editTagInput.setValue(tag['tagtext']);
    this.modalService.open(modelType == 'edit' ? this.tagEditModel : this.tagDeleteModel, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  };

  /**
   * Api call Edit tag
   */
  editTag() {
    if ((!this.editTagInput.value && !this.tagDetails.tagid) || this.editInputSpecialCharError) return;
    this.showActionSpinnerLoader = true;
    const data = {
      tagid: this.tagDetails.tagid,
      tagtext: this.editTagInput.value
    };

    this.tagmanagementservice.editTags(data).subscribe((res: any) => {
      if (res && res.status == 'success') {
        if (res.message == 'Dublicate Tag') {
          this.editTagInputError = true;
        } else {
          this.successMessage = 'Tag Edited Successfully!';
          this.fetchAllTags();
          this.editTagInput.setValue(null);
          this.editTagInputError = false;
          setTimeout(() => this.successMessage = '', 5000);
          this.dismiss();
        }
      } else {
        this.errorMessage = 'Something went wrong';
        setTimeout(() => this.errorMessage = '', 5000);
      }
      this.showActionSpinnerLoader = false;
    })

  }

  /**
   * Api call Delete tag
   */
  deleteTag() {
    if (!this.tagDetails.tagid) return;
    this.showActionSpinnerLoader = true;
    const data = {
      tagid: this.tagDetails.tagid,
    };

    this.tagmanagementservice.deleteTags(data).subscribe((res: any) => {
      if (res && res.status == 'success') {
        this.successMessage = 'Tag Deleted Successfully!';
        this.fetchAllTags();
        setTimeout(() => this.successMessage = '', 5000);
      } else {
        this.errorMessage = 'Something went wrong';
        setTimeout(() => this.errorMessage = '', 5000);
      }

      this.showActionSpinnerLoader = false;
      this.dismiss();
    })

  };

  /**
   * Dismiss model
   */
  dismiss() {
    this.modalService.dismissAll();
    this.showSpinnerLoader = false;
    this.showActionSpinnerLoader = false;
    this.tagDetails = {};
    this.editTagInput.setValue(null);
  };

}
